import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { TranslocoModule } from '@jsverse/transloco';
import { CurrencyMaskModule, CurrencyMaskConfig, CURRENCY_MASK_CONFIG } from 'ng2-currency-mask';
import { findCurrency } from 'currency-formatter';


import { InputDirectivesModule } from '@shared/directives/input-directives/input-directives.module';
import { InputPipesModule } from '@app/pipes/input-pipes/input-pipes.module';
import { FormCurrencyInputComponent } from '@forms/form-currency-input/form-currency-input.component';
import { environment as ENV } from '@environment';
import { GlobalPipesModule } from '@app/pipes/global-pipes.module';
import { ReservationServicesModule } from '@reservation/services/reservation-services.module';

const currencyData = findCurrency(ENV.countryInfo.currency_code);

export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
  align: 'left',
  allowNegative: false,
  decimal: ',',
  precision: ENV.currency_precision,
  prefix: currencyData && currencyData.symbol ? currencyData.symbol : '',
  suffix: '',
  thousands: '.'
};

@NgModule({
  declarations: [
    FormCurrencyInputComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    InputDirectivesModule,
    InputPipesModule,
    TranslocoModule,
    CurrencyMaskModule,
    GlobalPipesModule,
    ReservationServicesModule
  ],
  exports: [FormCurrencyInputComponent],
  providers: [
    { provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig }
  ]
})
export class FormCurrencyInputModule { }
